<template>
  <div class="stake">
    <div class="left">
      <div class="menus">
        <div class="menu">
          <div class="title" :class="{'active': userActive === 'staker'}" @click="selectElement('staker')">
            Staker
          </div>
          <template v-if="userActive === 'staker'">
            <div class="validator-items">
              <div class="validator-item" :class="{'validator-active': stakerActive === 'stakerStatus'}" 
                @click="selectStakerElement('stakerStatus')">
                -Status
              </div>
            </div>
          </template>
        </div>
        <div class="menu">
          <div class="title" :class="{'active': userActive === 'validator'}" @click="selectElement('validator')">
            Validator
          </div>
          <template v-if="userActive === 'validator'">
            <div class="validator-items">
              <div class="validator-item" :class="{'validator-active': validatorActive === 'validatorDeposit'}" 
                @click="selectValidatorElement('validatorDeposit')">
                -Deposit
              </div>
              <div class="validator-item" :class="{'validator-active': validatorActive === 'validatorStake'}" 
                @click="selectValidatorElement('validatorStake')">
                -Stake
              </div>
              <div class="validator-item" :class="{'validator-active': validatorActive === 'validatorStatus'}" 
                @click="selectValidatorElement('validatorStatus')">
                -Status
              </div>
            </div>
          </template>
        </div>
        
      </div>
    </div>

    <div class="right">
      <template v-if="userActive === 'staker'">
        <component
          :is="stakerComponent"
          @stake="stake"
          @stakeSuccess="stakeSuccess" />
      </template>

      <template v-if="userActive === 'validator'">
        <component
          :is="validatorComponent"
          :pool-info="poolInfo"
          @validatorStart="validatorStart"
          @validatorDepositSuccess="validatorDepositSuccess"
          @validatorStakeSuccess="validatorStakeSuccess"
          @validatorOffboardSuccess="validatorOffboardSuccess"
          @newValidatorDeposit="newValidatorDeposit"
          @jumpToPoolDetail='jumpToPoolDetail' 
          @validatorDetailBack='validatorDetailBack' />
      </template>

    </div>
    
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import rpc from '../util/rpc.js';
import { Toast } from 'mint-ui';
import Web3Util from '../util/web3Util.js';
import StakerUnstaked from '../components/StakerUnstaked';
import StakerStaked from '../components/StakerStaked';
import ValidatorProcess from '../components/ValidatorProcess';
import ValidatorDeposit from '../components/ValidatorDeposit';
import ValidatorStake from '../components/ValidatorStake';
import ValidatorStatus from '../components/ValidatorStatus';
import ValidatorStatusDetail from '../components/ValidatorStatusDetail';

const stakerUserActive = 'staker';

export default {
  name: 'reth',
  components: {
    StakerUnstaked,
    StakerStaked,
    ValidatorProcess,
    ValidatorDeposit,
    ValidatorStake,
    ValidatorStatus,
    ValidatorStatusDetail
  },
  data() {
    return {
      userActive: stakerUserActive,
      validatorActive: '',
      stakerActive: '',
      stakerComponent: 'StakerUnstaked',
      validatorComponent: 'ValidatorProcess',
      rethData: {},
      poolInfo: {}
    }
  },
  mounted() {
    // MetaMask Listener
    if (typeof window.ethereum !== 'undefined' && ethereum.isMetaMask) {
      ethereum.autoRefreshOnNetworkChange = false;
      ethereum.on('accountsChanged', (accounts) => {
        this.ethAccount = accounts[0];
        this.checkStakerStatus(this.ethAccount);
      })
    }
  },
  methods: {
    selectElement(name) {
      this.userActive = name;
      if (name == 'staker') {
        this.stake();
      } else {
        this.validatorActive = '';
        this.validatorComponent = 'ValidatorProcess';
      }
    },
    selectStakerElement(name) {
      this.userActive = stakerUserActive;
      if (name == 'stakerStatus') {
        this.stakerActive = 'stakerStatus';
        this.stakerComponent = 'StakerStaked';
      }
    },
    selectValidatorElement(name) {
      this.userActive = 'validator';
      this.validatorActive = name;
      if (name == 'validatorDeposit') {
        this.validatorComponent = 'ValidatorDeposit';
      } else if (name == 'validatorStake') {
        this.validatorComponent = 'ValidatorStake';
      } else if (name == 'validatorStatus') {
        this.validatorComponent = 'ValidatorStatus';
      }
    },
    checkStakerStatus(address) {
      if (address) {
        if (!(this.userActive == stakerUserActive && this.stakerComponent == 'StakerUnstaked')) {
          this.stake();
        }
      }
    },
    stake() {
      this.userActive = stakerUserActive;
      this.stakerActive = '';
      this.stakerComponent = 'StakerUnstaked';
    },
    validatorStart() {
      this.selectValidatorElement('validatorDeposit');
    },
    stakeSuccess() {
      this.selectStakerElement('stakerStatus');
      this.$emit('refreshEthBalance');
    },
    validatorDepositSuccess() {
      this.selectValidatorElement('validatorStake');
      this.$emit('refreshEthBalance');
    },
    validatorStakeSuccess() {
      this.selectValidatorElement('validatorStatus');
      this.$emit('refreshEthBalance');
    },
    validatorOffboardSuccess() {
      this.selectValidatorElement('validatorDeposit');
      this.$emit('refreshEthBalance');
    },
    newValidatorDeposit() {
      this.selectValidatorElement('validatorDeposit');
    },
    jumpToPoolDetail(address, status, from) {
      this.poolInfo = {
        address: address,
        status: status,
        from: from
      };
      this.userActive = 'validator';
      this.validatorComponent = 'ValidatorStatusDetail';
    },
    validatorDetailBack(from) {
      if (from == 'status') {
        this.validatorComponent = 'ValidatorStatus';
      } else if (from == 'stake') {
        this.validatorActive = 'validatorStake';
        this.validatorComponent = 'ValidatorStake';
      }
    }
  },
  created() {
    if (!(typeof window.ethereum !== 'undefined' && ethereum.selectedAddress)) {
      this.$router.push('/');
    } else {
      if (this.$route.params && this.$route.params.source) {
        if (this.$route.params.source == 'stakerUnstaked') {
          this.stake();
        } else {
          this.selectValidatorElement(this.$route.params.source);
        }
        return;
      }

      let address = ethereum.selectedAddress;
      let web3 = Web3Util.getWeb3();

      let managerContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolManagerAbi(), Web3Util.getStafiStakingPoolManagerAddress(), {
        from: address
      });
      managerContract.methods.getNodeStakingPoolCount(address).call().then(poolCount => {
        if (poolCount > 0) {
          this.selectValidatorElement('validatorStatus');
        }
      });

      let contract = new web3.eth.Contract(Web3Util.getRETHTokenAbi(), Web3Util.getRETHTokenAddress(), {
        from: address
      });
      contract.methods.balanceOf(address).call().then(result => {
        if (result > 0) {
          this.selectStakerElement('stakerStatus');
        }
      });
    }
  }
}
</script>

<style lang="scss">
@import "../mixin.scss";

.stake {
  background-color: #2B3239;
  width: 683px;
  padding-bottom: 50px;
  border-radius: 19px;

  display: flex;

  .left {
    margin-left: 32px;
    margin-top: 11px;
    padding-right: 20px;
    padding-top: 21px;
    border-right: 1px solid #474747;

    .menus {
      .menu {
        cursor: pointer;
        margin-bottom: 33px;
        .title {
          font-size: 14px;
          font-weight: bold;
          text-align:right;
        }

        .active {
          color: #00F3AB;
        }

        .validator-items {
          text-align:right;
          .validator-item {
            font-size: 12px;
            font-weight: normal;
            margin-top: 5px;
            color: #fff;
          }

          .validator-active {
            color: #00F3AB;
          }
        }

      }
    }
  }

  .right {
    margin-left: 46px;
    padding-right: 20px;

    .title {
      font-size: 30px;
      font-weight: bold;
      margin-top: 36px;
    }

    .inputs {
      margin-top: 60px;
      width: 442px;
      height: 50px;
      border-radius: 3.65px;
      border: 1px solid #BFBFBF;
      padding-left: 25px;
      position: relative;
      
      .icon {
        height: 36px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
        img {
          height: 100%;
        }
      }
      input {
        font-size: 22px;
        font-weight: bold;
        width: 390px;
        height: 48px;
        background-color: #2B3239;
        border: 0;
        color: #fff;

        &:focus {
          outline: none
        }
      }
    }

    .desc {
      color: #C4C4C4;
      font-size: 16px;
      margin-top: 30px;
      .pool {
        cursor: pointer;
        color: #00F3AB;
        text-decoration: underline;
      }
    }

    .items {
      margin-top: 60px;
      .item {
        margin-bottom: 32px;

        .item-title {
          font-size: 16px;
        }

        .item-value {
          font-size: 30px;
          color: #00F3AB;
          font-weight: bold;
        }
      }
    }
    
  }

}
</style>
